// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Chamados_DividirInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Chamados_DividirInput — POST /chamados/dividir.
 *
 * Um chamado grande vira vários pequenos. Cada parte traz só assunto, descrição
 * e (opcional) prioridade: franquia, autor e contexto são COPIADOS do chamado
 * de origem pelo controller, nunca enviados — é a regra 1 do domínio (nenhum
 * contrato de entrada tem campo de autor), e é o que faz o solicitante
 * enxergar as partes como suas.
 *
 * Os limites de assunto e descrição são os de Chamados_AbrirInput, pelo mesmo
 * motivo: `assunto` é varchar(100) e o sql_mode não-estrito truncaria em
 * silêncio.
 */
import type { Chamados_ParteInputRow } from './Chamados_ParteInputRow'
import { registerContract } from './validate'

export interface Chamados_DividirInput {
chamado_id: number
partes?: Chamados_ParteInputRow[]
}

registerContract('Chamados_DividirInput', {
  chamado_id: { type: 'number',  required: true },
  partes: {
    type: 'array',
    required: false,
    items: {
      assunto:    { type: 'string',  required: false },
      descricao:  { type: 'string',  required: false },
      prioridade: { type: 'string',  required: false },
    },
  },
})
